import Image from "next/legacy/image";
import React from "react";
import KelasLiveImg from "public/assets/usp/kelas-live.png";
import LatihanMingguanImg from "public/assets/usp/latihan-mingguan.png";
import LaporanBelajarImg from "public/assets/usp/laporan-belajar.png";
import CheckIcon from "public/assets/usp/check-icon.svg";
import BracketArrow from "public/assets/usp/bracket-arrow.svg";
import DownArrow from "public/assets/usp/down-arrow.svg";
import {
  UspSectionWrapper,
  UspTitle,
  UspCardsRow,
  UspCard,
  UspCardTitle,
  UspCardSubtitle,
  UspCardImage,
  UspCardBullets,
  UspBulletItem,
  UspBulletIcon,
  UspBulletText,
  UspPlusSeparator,
  UspBracketArrow,
  UspMobileArrow,
  UspOutcomeSection,
  UspOutcomeYellow,
  UspDownArrow,
  UspOutcomeWhite
} from "./usp-section.styles";
import { StaticImageData } from "next/legacy/image";

interface UspCardData {
  title: string;
  subtitle: string;
  image: StaticImageData;
  bullets: string[];
  imagePosition?: string;
}

const uspCards: UspCardData[] = [
  {
    title: "Kelas Live",
    subtitle: "Bangun Keinginan Belajar",
    image: KelasLiveImg,
    bullets: [
      "Durasi 60 menit per pertemuan",
      "Kelas bersama Guru Juara & teman yang sama selama satu semester"
    ]
  },
  {
    title: "Latihan Mingguan",
    subtitle: "Buat Pelajaran Melekat",
    image: LatihanMingguanImg,
    bullets: [
      "Anak harus menulis coretan di kertas",
      "Soal bukan pilihan ganda"
    ]
  },
  {
    title: "Laporan Belajar",
    subtitle: "Jaga Motivasi Anak Bersama",
    image: LaporanBelajarImg,
    bullets: [
      "Langsung ke WhatsApp orang tua",
      "Pantau kehadiran dan kesiapan anak untuk TKA/ PAS/ PAT/ SNBT"
    ]
  }
];

export const UspSection: React.FC = () => {
  return (
    <UspSectionWrapper>
      <UspTitle>Dengan Rp90.000 dapat apa saja di CoLearn?</UspTitle>
      <UspCardsRow>
        {uspCards.map((card, index) => (
          <React.Fragment key={card.title}>
            <UspCard>
              <UspCardTitle>{card.title}</UspCardTitle>
              <UspCardImage $objectPosition={card.imagePosition}>
                <Image
                  src={card.image}
                  alt={card.title}
                  layout="fill"
                  objectFit="cover"
                  objectPosition={card.imagePosition || "center"}
                />
              </UspCardImage>
              <UspCardSubtitle>{card.subtitle}</UspCardSubtitle>
              <UspCardBullets>
                {card.bullets.map((bullet) => (
                  <UspBulletItem key={bullet}>
                    <UspBulletIcon>
                      <Image
                        src={CheckIcon}
                        alt="check"
                        width={32}
                        height={32}
                      />
                    </UspBulletIcon>
                    <UspBulletText>{bullet}</UspBulletText>
                  </UspBulletItem>
                ))}
              </UspCardBullets>
            </UspCard>
            {index < uspCards.length - 1 && (
              <UspPlusSeparator>
                <span>+</span>
              </UspPlusSeparator>
            )}
          </React.Fragment>
        ))}
      </UspCardsRow>
      <UspBracketArrow>
        <Image src={BracketArrow} alt="" layout="fill" />
      </UspBracketArrow>
      <UspMobileArrow>
        <Image src={DownArrow} alt="" width={76} height={60} />
      </UspMobileArrow>
      <UspOutcomeSection>
        <UspOutcomeYellow>
          <div>
            <p>Fondasi Matematika Kuat</p>
          </div>
        </UspOutcomeYellow>
        <UspDownArrow>
          <Image src={DownArrow} alt="" width={76} height={60} />
        </UspDownArrow>
        <UspOutcomeWhite>
          <div>
            <p>
              <span className="bold">Siap Hadapi TKA</span>
              <span className="regular">/PAS/PAT/SNBT</span>
            </p>
          </div>
        </UspOutcomeWhite>
      </UspOutcomeSection>
    </UspSectionWrapper>
  );
};
